export const getShareUrl = (path: string, search: string) => {
	const { hostname, protocol } = window.location;
	return `${protocol}//${hostname}${path}${search}${
		search !== '' && search !== undefined ? '&' : '?'
	}shared`;
};
